import React from "react";
import "../styles/Section.css";

const Footer = () => (
  <footer>
    <p>© 2026 SoftCo | Privacy Policy | Terms</p>
    <div className="socials">
      <a href="https://www.linkedin.com/in/saad-siddiqui-97442a23a/" target="_blank" rel="noreferrer">LinkedIn</a>
      {/* <a href="https://twitter.com" target="_blank" rel="noreferrer">Twitter</a> */}
      <a href="https://github.com/Saadsiddiqui10" target="_blank" rel="noreferrer">GitHub</a>
    </div>
  </footer>
);

export default Footer;
